import { useQueries } from '@tanstack/react-query';

import { LabelModel } from '../../models/label.model';

import API from '../../services/api';

import labelKeys from './_queryKeys';

const getLabels = async (componentTypeId: string): Promise<LabelModel[]> => {
    const { data } = await API.getLabelsV1(componentTypeId);

    return data;
};

export default function useLabelsByComponentTypesQuery(
    componentTypeIds: string[],
    options = { enabled: true },
) {
    const labelQueries = useQueries({
        queries: componentTypeIds.map((componentTypeId) => ({
            queryKey: labelKeys.labelsByComponentId(componentTypeId),
            queryFn: async () => await getLabels(componentTypeId),
            enabled: (options?.enabled ?? true) && !!componentTypeId,
        })),
    });

    return {
        isLoading: labelQueries.some((query) => query.isLoading),
        isError: labelQueries.some((query) => query.isError),
        isSuccess: labelQueries.every((query) => query.isSuccess),
        labelsByComponentType: componentTypeIds.reduce((acc, typeId, index) => {
            acc[typeId] = labelQueries[index].data ?? [];
            return acc;
        }, {} as Record<string, LabelModel[]>),
    };
}
